import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IProfile, IResponse  } from '@interfaces/index';
import { AppService } from '@ui-components/services';
import { MatDialog } from '@angular/material/dialog';
import { switchMap } from 'rxjs';
import { ProfileService } from '../../services/profile.service';
import { IProfessional } from 'projects/ui-components/src/interfaces/IProfile';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-professional',
  templateUrl: './professional.component.html',
  styleUrl: './professional.component.scss'
})
export class ProfessionalComponent {

  form: FormGroup;
  loading = false;
  profile: IProfile | null = null;
  professional: IProfessional | null = null;
  person_id: number | undefined;


  constructor(
    protected _app_service: AppService,
    protected _profile_service: ProfileService,
    protected _fb: FormBuilder,
    protected _route: ActivatedRoute,
    public router: Router,
    public dialog: MatDialog
  ) {
    this.form = this._fb.group({
      job_title: [null, Validators.required],
      org_name: [null,  Validators.required],
      person_id: [null]
    })
  }

  ngOnInit() {
 
    this._app_service.getProfile().pipe(
      switchMap(
        (response: IResponse<IProfile>) => {
          this.profile = response.data;
          const person_id_param = this._route.snapshot.paramMap.get('person_id');
          this.person_id = person_id_param ? +person_id_param : undefined;
          this.form.patchValue({person_id: this.person_id});
          return this._profile_service.getProfessional(this.person_id);
        }
      )
    ).subscribe(
      (response: IResponse<IProfessional>) => {
        this.form.patchValue(response.data);
      }
    )
  }

  update(){
    this._profile_service.updateProfessional(this.form.value).subscribe(
      (response: IResponse<IProfessional>) => {
        this.professional = response.data;
      }
    )
  }


}

